// extracted by mini-css-extract-plugin
export default {"header":"gu","fullPage":"hu","closed":"iu","minimize":"ju","redcircle":"ku","container":"lu","text":"mu","centered":"nu","escapex":"ou"};
    if(module.hot) {
      // 1726593103427
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  